import { render, staticRenderFns } from "./CustomerTicketEdit.vue?vue&type=template&id=955bcb08&"
import script from "./CustomerTicketEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerTicketEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTicketEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports